import { TableHeader } from "@/models";

export const rateQueueHeaders: TableHeader[] = [
  {
    text: "Facility",
    value: "location_code"
  },
  {
    text: "Unit Type",
    value: "type_name"
  },
  {
    text: "Unit Size",
    value: "width"
  },
  {
    text: "Current Rate",
    value: "current_rate"
  },
  {
    text: "New Rate",
    value: "new_rate"
  },
  {
    text: "Δ GPI",
    value: "gpi"
  },
  {
    text: "Avg. IPR",
    value: "ipr_avg"
  },
  {
    text: "Floor",
    value: "is_first_floor"
  },
  {
    text: "Vacant",
    value: "total_vacant"
  },
  {
    text: "Units",
    value: "total_units"
  },
  {
    text: "Ins/Outs/Net",
    value: "net_move_ins" // to sort on last portion of "Ins/Outs/Nets"
  },
  {
    text: "Occ. %",
    value: "occupancy_percent"
  },
  {
    text: "Days Same",
    value: "daySame"
  },
  {
    text: "Queued",
    value: "queued"
  },
  {
    text: "",
    value: "data-table-expand"
  }
];
